import { useAutoTranslation } from "@/entities"
import {
  authControllerResetPasswordRequest,
  type ResetPasswordDtoReq,
} from "@/shared/api/generated"
import { LANG_KEYS } from "@/shared/constants"
import { useMutation } from "@tanstack/react-query"
import { useForm } from "react-hook-form"
import { toast } from "sonner"

export function useResetPassReqForm() {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<{ email: string }>({
    defaultValues: {
      email: "",
    },
  })

  const { t } = useAutoTranslation()

  const formMutation = useMutation({
    mutationFn: (data: ResetPasswordDtoReq) =>
      authControllerResetPasswordRequest(data),
    async onSuccess() {
      toast.success(t(LANG_KEYS.CHECK_YOUR_EMAIL_TO_UPDATE_YOUR_PASSWORD), {
        duration: 1000 * 60 * 5, // 5 minutes,
        dismissible: true,
        closeButton: true,
      })
      reset()
    },
  })

  return {
    handleSubmit: handleSubmit(values => {
      formMutation.mutate(values)
    }),
    isLoading: formMutation.isPending,
    errors,
    control,
  }
}
